export enum NotificationActionTypes {
  ACTION_GET_UNREAD_COUNT = 'ACTION_GET_UNREAD_COUNT',
  ACTION_INIT_WEBSOCKET = 'ACTION_INIT_WEBSOCKET',
  ACTION_CLOSE_WEBSOCKET = 'ACTION_CLOSE_WEBSOCKET'
}